const exampleActionBarConfigProp = {
  config: {
    key: "action-bar",
    general: {
      visibility: true,
      style: {
        label: "Hero",
        value: "hero",
      },
    },
  },
};

export default exampleActionBarConfigProp;
